import { app } from '../../../../../../../bootstrap/core';
import { ibanPropertyComponent } from './ibanProperty.component';

app.component('ibanProperty', ibanPropertyComponent);
